import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-lg-10" }
const _hoisted_3 = { class: "col-lg-2" }
const _hoisted_4 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-header text-center" }
const _hoisted_7 = { class: "card-body text-center" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "card-text" }
const _hoisted_16 = {
  key: 1,
  class: "card mb-3"
}
const _hoisted_17 = { class: "card-header text-center" }
const _hoisted_18 = { class: "card-body text-center time" }

import {MainService} from '@/services/main.service';
import {onBeforeMount, onMounted, ref} from 'vue';
import {SessionManager} from '@/services/session.manager';
import {StudentModel} from "@/models/student.model";
import {useLogout} from "@/hooks/logout.hook";
import {useTranslate} from "@/hooks/translate.hook";


export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const displayStudentImage = process.env.VUE_APP_DISPLAY_STUDENT_IMAGE === "true"
const time = ref<string>()
const srvTime = ref<Date>(new Date())
const logout = useLogout()
const studentImgUrl = ref()
const t = useTranslate()

const student = ref<StudentModel>()
MainService.getStudent().then(rsp => {
  studentImgUrl.value = `https://ecms.singidunum.ac.rs/${rsp.data.index}`
  student.value = rsp.data
}).catch(e => {
  logout()
})

onMounted(async () => {
  const rsp = await MainService.getServerTime()
  srvTime.value = new Date(rsp.data.time)
  setInterval(function () {
    srvTime.value.setSeconds(srvTime.value.getSeconds() + 1);
    time.value = srvTime.value.toLocaleTimeString('sr-RS')
  }, 1000);
})

onBeforeMount(() => {
  // You are not logged in, go back to login page
  if (!SessionManager.hasAuth()) {
    logout()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "main")
    ]),
    _createElementVNode("div", _hoisted_3, [
      (student.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "image", {}, () => [
              displayStudentImage
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "card-img-top",
                    src: studentImgUrl.value,
                    alt: "student"
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h5", _hoisted_6, _toDisplayString(_unref(t)("layout.student")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createTextVNode(_toDisplayString(student.value.index), 1),
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(student.value.firstName) + " " + _toDisplayString(student.value.lastName), 1),
                _hoisted_10
              ]),
              (student.value.isAllowedOnline || student.value.isEmployed)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                    (student.value.isAllowedOnline)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "fa-solid fa-globe me-1",
                          title: _unref(t)('layout.online')
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    (student.value.isEmployed)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: "fa-solid fa-suitcase",
                          title: _unref(t)('layout.employed')
                        }, null, 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_14,
              _createElementVNode("p", _hoisted_15, _toDisplayString(student.value.faculty.name), 1),
              _renderSlot(_ctx.$slots, "button", {}, () => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(logout)()))
                }, _toDisplayString(_unref(t)("layout.button")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (time.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("h5", _hoisted_17, _toDisplayString(_unref(t)("layout.time")), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(time.value), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})